//活动弹窗通知
import store from '@/store/index';
import DialogNotice from '@/packages/dialogNotice/index.js';
import { Base64 } from 'js-base64';
const md5 = require('md5');
import { getNotice } from '@/api/task';
import NewYearScroll from '@/packages/newYearScroll/index.js';

//获取本地存的NoticeData
function getLocalNoticeData() {
	let app = store.state.app;
	return new Promise((resolve) => {
		if (app.platform == 0) {
			resolve(store.state.notice.data);
		} else {
			return window.nativeUtils.getData('noticeData').then((data) => {
				if (data) {
					resolve(Base64.decode(data));
				} else {
					resolve('');
				}
			});
		}
	});
}

//获取当天23点59分59秒的时间戳
function getTimestamp() {
	return new Date(new Date(new Date().toDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime();
}

//获取当前时间戳
function getCurrentTimestamp() {
	return new Date().getTime();
}

function checkActNotice(gameID) {
	let app = store.state.app,
		appInfo = app.appInfo;
	const params = {
		identity: appInfo.identity,
		game_id: gameID
	};
	
	getLocalNoticeData().then((res) => {
		let localData = '';
		if (res) {
			localData = JSON.parse(res);
		}
		getNotice(params).then((res) => {
			res = res.data;
			const userKey = app.platform == 0 ? appInfo.identity : store.state.user.userId; //用户的key
			if (res.result.data && res.result.data.length > 0) {
				const currentKey = md5(JSON.stringify(res.result));
				const alertType = parseInt(res.result.alert_type);
				//一次性弹窗，弹窗完毕之后，记录当前key
				const saveData = {
					identity: userKey,
					timestamp: getTimestamp(),
					alertType: alertType,
					key: currentKey,
					gameID: gameID
				};

				if (localData) {
					let arrLocalData = Array.from(localData);
					//如果本地不存在此游戏信息则弹窗并更新本地存储的信息
					if (arrLocalData.findIndex((item) => item.gameID == gameID && item.identity == userKey) == -1) {
						arrLocalData.push(saveData);
						saveDataToLocal(app, arrLocalData);
						pop(res, userKey, gameID);
					} else {
						//本地有此游戏的弹窗信息
						const currentGameInfo = arrLocalData.find(
							(item) => item.gameID == gameID && item.identity == userKey
						);
						//本地存在则先对比key是否相等，key不相等
						if (currentGameInfo.key != currentKey) {
							arrLocalData = arrLocalData.filter(
								(item) => item.gameID != gameID && item.identity != userKey
							);
							arrLocalData.push(saveData);
							saveDataToLocal(app, arrLocalData);
							pop(res, userKey, gameID);
						} else {
							//key相等，则判断是否过了上次弹窗记录的23点59分59秒且弹窗类型是循环弹窗
							if (currentGameInfo.timestamp < getCurrentTimestamp() && currentGameInfo.alertType == 1) {
								arrLocalData = arrLocalData.filter(
									(item) => item.gameID != gameID && item.identity != userKey
								);
								arrLocalData.push(saveData);
								saveDataToLocal(app, arrLocalData);
								pop(res, userKey, gameID);
							} else {
								//显示春联
								NewYearScroll.service(userKey, gameID);
							}
						}
					}
				} else {
					localData = new Array();
					localData.push(saveData);
					saveDataToLocal(app, localData);
					pop(res, userKey, gameID);
				}
			} else {
				//显示春联
				NewYearScroll.service(userKey, gameID);
			}
		});
	});
}

//保存数据到本地
function saveDataToLocal(app, saveData) {
	const saveDataStr = JSON.stringify(saveData);
	if (app.platform == 0) {
		store.dispatch('setNoticeData', saveDataStr);
	} else {
		window.nativeUtils.setData('noticeData', Base64.encode(saveDataStr));
	}
}

//弹窗
function pop(res, userKey, gameID) {
	if (window.__dialogNotice) {
		return;
	}
	window.__dialogNotice = DialogNotice.service({
		data: res.result.data,
		userKey: userKey,
		gameID: gameID,
		style: store.state.app.appInfo.style
	});
}

function init(gameID) {
	checkActNotice(gameID);
}
const actNotice = {
	init: (gameID) => {
		init(gameID);
	}
};
export default actNotice;
